import { render, staticRenderFns } from "./RequestedNewProcessList.vue?vue&type=template&id=565a39cd&scoped=true&"
import script from "./RequestedNewProcessList.vue?vue&type=script&lang=js&"
export * from "./RequestedNewProcessList.vue?vue&type=script&lang=js&"
import style0 from "./RequestedNewProcessList.vue?vue&type=style&index=0&id=565a39cd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565a39cd",
  null
  
)

export default component.exports